<template>
  <el-dialog title="付款单" :visible.sync="dialogFormVisible" custom-class="fix-dialog" center :close-on-click-modal="false"
    :append-to-body="true" :modal="true">
    <el-form :model="form" ref="formPayInfo" :rules="rules">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <template slot="title">
            <span>基本信息</span>
          </template>
          <el-row>
            <el-col :span="8">
              <el-form-item label="申请人" :label-width="formLabelWidth"> {{ form.uname }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="部门" :label-width="formLabelWidth"> {{ form.dname }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="填单日期" :label-width="formLabelWidth"> {{ form.adddate }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="退款事由" :label-width="formLabelWidth" prop="remark">
                <el-input type="textarea" placeholder="" v-model="form.remark"  :autosize="{ minRows: 2, maxRows: 20}" :required="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="客户" :label-width="formLabelWidth" prop="hetongname">
                <span v-if="form.unitguid">{{form.hetongname}}</span>
                <AutoCustomer ref="AutoCustomer1" @clear="clearCustomerName" :size="'small'"  @handleSelect="afterSelExternalDept" :unitgroup="''" :content="form.hetongname" v-else></AutoCustomer>
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">
            <div style="display:inline-block;width:100%;">
              <span style="float:left">订单明细</span>
              <div style="float:right;padding-right: 20px">
                合计：<span style="color: red"><b>{{totalmoney}}</b></span>
              </div>
            </div>
          </template>
          <el-table :data="orderTable" size="mini" stripe border style="width: 100%;" ref="multipleTable"
                    @selection-change="handleSelectionChange">
            <el-table-column align="center" header-align="center" label="序" width="60">
              <template slot-scope="scope">
              {{1+scope.$index}}
              </template>
            </el-table-column>
            <el-table-column prop="feedate" label="订单" align="left" header-align="center" width="140">
              <template slot-scope="scope">
                {{ scope.row.htqd}}<br>
                {{ scope.row.erpserial}}<br>
                金额： <span style="color: red"><b>{{( (scope.row.htje||0)+(scope.row.discount||0) ) | numeric(2)}}</b></span><br>
                退货率：<span style="font-size: large;color: red"><b>{{scope.row.sumnumber}}</b></span>%
              </template>
            </el-table-column>
            <el-table-column prop="seedname" align="left" header-align="center" label="商品" width="350">
              <template slot-scope="scope">
                <div v-for="(item1,index1) in scope.row.jxcformdetailDOList" style="min-height: 70px"
                     :style="{paddingTop: '5px',paddingBottom: '5px',borderTop:index1>0?'1px solid #EEEEEE':'none'}">
                  <!--<img style="width:70px;height:70px;margin-left: 10px;" :src="item1.imageUrl||''"  @error="imgError"/>-->
                  <p class="alignleft">
                    <span class="cp_title">{{item1.seedname}}</span>
                    <span class="cp_title" v-if="item1.subseedname" style="padding-left: 20px">{{item1.subseedname}}</span>
                    <span>x {{item1.totalnumber||0}}</span>
                  </p>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="remark" align="left" header-align="center" label="备注" width="500">
              <template slot-scope="scope">
                <div v-html="getLiuYan(scope.row.remark)"  style="text-align: left;padding-left: 5px;padding-right: 5px;" class="color-grey"></div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="right" width="100">
              <template slot-scope="scope">
                <el-button size="mini" @click="lookDetails(scope.row)">查看</el-button><el-button size="mini" style="margin-top: 20px" v-if="form.casestatus=='6'&&form.formAllowEdit&&isFinancial&&form.unitguid" @click="tuikuan(scope.row)">退款</el-button>
              </template>
            </el-table-column>
            <el-table-column type="selection" v-if="form.formAllowEdit&&!form.unitguid" width="55"></el-table-column>
          </el-table>
        </el-collapse-item>
        <el-collapse-item name="6">
          <template slot="title">
            <span>审批流程</span>
          </template>
          <el-row>
            <el-col :span="24">
              <WorkflowView ref="wfView"></WorkflowView>
            </el-col>
          </el-row>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <WorkflowButton ref="wfHandle" @saveWorkFlow="saveData" @deleteWorkFlow="deleteData" @closeDialog="dialogFormVisible = false"></WorkflowButton>
    </div>
    <span slot="title" style="font-size: larger;">
      <div>{{ form.feename }} <span class="erpserial">{{ form.erpserial }}</span></div>
    </span>
    <CstagreementMachiningEdit ref="machiningedit"></CstagreementMachiningEdit>
    <CstagreementEdit ref="DataContactEdit"></CstagreementEdit>
    <ConfirmRefundEdit ref="ConfirmRefundEdit"  @bindGrid="bindOrder()"></ConfirmRefundEdit>
  </el-dialog>
</template>
<style scoped>
  .erpserial {
    font-size: 10px;
  }

  .span-budgettype {
    border: 1px solid #00CCCD;
    color: #00CCCD;
    margin-left: 10px;
    padding: 3px;
    cursor: pointer;
  }
</style>
<script>
  import {
    saveOrderBack,
    getDetail,
    deleteData
  } from "@/api/pay/paymain";
  import {
    getUnSubmitPayDetailList,
    deleteFeeDetail,
    getPayDetailByPayGuid
  } from "@/api/pay/paydetail";
  import {convertToBigMoney,ConvertMoney} from "@/plugin/ordercommon";
  import {getCstagreementListDataNew } from '@/api/set/csagreement';
  import {getRemark} from '@/plugin/ordercommon'
  import CstagreementMachiningEdit from '../../testorder/cstagreement/CstagreementMachiningEdit';
  import CstagreementEdit from '../../testorder/cstagreement/CstagreementEdit';
  import ConfirmRefundEdit from '../../testorder/cstagreement/ConfirmRefundEdit';

  export default {
    name: "OrderBackEdit",
    data() {
      return {
        isFinancial: false,
        workflowParam: {}, //工作流参数，这个地方用来存储下，方便在线支付确认后重新调用保存方法
        dialogFormVisible: false,
        activeNames: ["1", "2", "3", "4", "5", "6"],
        isClickEvent: true, //选择供应商、客户清空图标按钮不触发click事件使用
        isShow: false,
        bankArray: [],
        totalmoney:0,
        form: {
          //定义表单参数（不要在这里赋默认值 统一在initForm中初始化）
          formAllowEdit: true,
          unitguid: "",
          summary: "",
          paymoney: "", //
          casestatus: "", //上级部门
          casestepname: "",
          flag: "",
          remark: "",
          applyby: "",
          tenantid:'',
          applybyguid: "",
          applybydname: "",
          applybydserial: "",
          hetongname: "",
          hetongserial: "",
          currency: "",
          customername: "",
          customerserial: "",
          bank: "",
          bankaccount: "",
          bankname: "", //银行名称
          formtype: "TK",
          formname: "退款单", //报销单BX;付款单ZF;备用金申请单
          feetype: "", //费用大类编码
          feename: "",
          exchangerate: "1", //税率
          paydate: "",
          payuname: "",
          payuguid: "",
          offsetcash: 0, //抵消备用金
          offsetcashjson: '', //抵消备用金明细
          localcurrency: "", //折算本币金额
          bigfeemoney: "", //大写金额
          erpserial: "", //单据号
          shouxufee: "", //手续费
          paymethoddata: [], //付款方式
          payyusuandata: [], //使用预算信息
          financialmenucode: "", //蜘蛛财务费用菜单编码
        },
        parentCategoryName: "", //给费用明细页面传值用
        parentCategoryCode: "", //给费用明细页面传值用
        feecode: "", //选择的费用类别编码
        feename: "", //选择的费用类别名称
        needfapiao: true, //选择的费用是否需要发票，默认需要
        MustFaPiao: false,
        tableDataFee: [], //费用列表
        tableDataYuSuan_Show: [], //显示在表格中的预算费用（同一预算只显示个人或者是部门的，可切换）
        tableDataYuSuan_All: [], //从数据库获取的所有预算使用情况
        currencyData: [{
          text: "人民币",
          value: "RMB"
        }], //币种
        isPayStep: false, //是否付款步骤
        formLabelWidth: "120px",
        todolist: [],
        orderTable:[],
        rules: {
          remark: [{
            required: true,
            message: "请填写退款事由",
            trigger: "blur"
          }]
        }
      };
    },
    computed: {
      //获取大写金额
      bigfeemoney: function() {
        return convertToBigMoney(this.form.paymoney);
      }
    },
    methods: {
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
        this.sumTotalMoney();
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        this.sumTotalMoney();
      },
      sumTotalMoney(){
        this.totalmoney=0;
        for(let i in this.multipleSelection){
          this.totalmoney+=parseFloat(this.multipleSelection[i].htje|0)+parseFloat(this.multipleSelection[i].discount|0)
        }
        this.totalmoney=Math.abs(this.totalmoney).toFixed(2);
      },
      tuikuan(item) {
        this.$refs.ConfirmRefundEdit.initData(item)
      },
      lookDetails(row) {
        if (row.jxcformdetailDOList != null && row.jxcformdetailDOList[0].filltemplate == "50") {
          this.$refs.machiningedit.initData(row)
          this.$refs.machiningedit.show('customerservice')
        } else {
          this.$refs.DataContactEdit.initData(row)
          this.OpenDialog()
        }
      },
      OpenDialog() {
        this.$refs.DataContactEdit.yincangdayin()
        this.$refs.DataContactEdit.show()
      },
      getLiuYan(remark) {
        return getRemark(remark);
      },
      bindOrder() {
        if (!this.form.hetongserial) return;
        var limit = 1000;
        var formData = {
          needtuihuoinfo: 0,
          offset: 0,
          limit: limit,
          search: '',
          status: 700,
          statuses: '',
          formtype: 42,
          seedcode: '',
          categorycode: '',
          independentserial: 'all',
          customerserial: this.form.hetongserial,
          pcustomerserial: '',
          needdetail: "1",
          paymethod: '',
          orderfill: '',
          isshowbuyinfo: 0,
          isshowstore: 0,
          isshowpayinfo: 0,
          isshowtuihuofrombuy: 0,
          neefahuoinfo: 0,
          isreturnorder: '-999',
          fileuname: '',
          cangkucode: "",
          datetype: 10,
          startdate: "2023-01-01",
          enddate: "",
          erpserials: '',
          erpserial: '',
          tracknum: '',
          invoicesource: '',
          iswriteorder: '',
          shoudongcaigou: '',//  手动采购 1未审核 2审核通过
          purchase: '',// 仓库岗待收货 用
          needtotal: "-1",//不计算记录总数
          uname: '',
          exceedtime: '',
          showbackpercent: '1'
        };
        this.orderTable = [];
        this.multipleSelection = [];
        this.totalmoney = 0;
        getCstagreementListDataNew(formData, true).then(response => {
          var trows = response.data.obj.rows;
          if (this.form.unitguid) {//修改状态下根据提交时选择的订单显示内容
            for (let i in trows) {
              if (this.form.offsetcashjson.indexOf(';' + trows[i].erpserial + ';') > -1) {
                this.orderTable.push(trows[i]);
                this.multipleSelection.push(trows[i]);
                console.log(this.orderTable)
              }
            }
            this.sumTotalMoney();
          }else {
            this.orderTable = trows;
          }
        }).catch((error) => {
        });
      },
      //客服填写订单选择门店之后模拟登录
      afterSelExternalDept(customerserial, customername, row) {
        this.form.hetongserial=customerserial;
        this.form.hetongname=customername;
        this.bindOrder();
      },
      clearCustomerName() {
        this.form.hetongserial='';
        this.form.hetongname='';
        this.orderTable=[];
        this.multipleSelection = [];
        this.totalmoney=0;
      },
      addPage() {
        //新增
        this.initForm();
        this.form.formname = "退款单";
        this.form.formtype = "TK";
        this.form.feetype = 'orderback';
        this.form.feename = '销售单退款';
        this.isPayStep = false; //是否付款步骤
        this.form.exchangerate = "1"; //税率
        this.tableDataFee = [];
        this.tableDataYuSuan_Show = [];
        this.tableDataYuSuan_All = [];
        var userinfo =this.userModel;
        this.form.uguid = userinfo.uguid;
        this.form.uname = userinfo.uname;
        this.form.dserial = userinfo.dserial;
        this.form.dname = userinfo.dname;
        this.form.applyby = userinfo.uname;
        this.form.applybyguid = userinfo.uguid;
        this.form.applybydserial = userinfo.dserial;
        this.form.applybydname = userinfo.dname;
        var today = new Date();
        this.form.adddate =
          today.getFullYear() +
          "-" +
          (today.getMonth() + 1) +
          "-" +
          today.getDate();
        //根据uguid，和分类编码  绑定费用明细
        this.form.formAllowEdit = true;
        this.$refs.wfHandle.InitAddButton(); //初始化 第一次提交时的工作流按钮

      },
      editPage(unitguid) {
        this.initForm();
        getDetail({
          unitguid: unitguid
        }).then(response => {
          this.form = response.data.obj;
          this.form.flag = false; //修改状态下 flag=false
          //payguid绑定费用明细
          this.todolist = response.data.todolist;
          this.parentCategoryCode = this.form.feetype; //给费用明细页面传值用
          this.parentCategoryName = this.form.feename; //给费用明细页面传值用
          var wfData=JSON.parse(this.form.workflow);
          this.form.formAllowEdit = this.$refs.wfHandle.InitButton(wfData); //初始化 审批过程中的工作流按钮

          this.bindOrder();
          this.$refs.wfView.initData(response.data.todolist, this.form.formAllowEdit); //初始化 审批流程

          if (parseFloat(this.form.casestatus) >= 6) {
            //出纳办理
            this.isPayStep = true;
            this.activeNames = ["1", "2", "3", "4", "5", "6"];

            this.form.payuguid = this.userModel.uguid;
            this.form.payuname =  this.userModel.uname;
          }
          //收款信息展示,渲染图片
          if (this.form.customername) {
            this.isShow = true;
          }
        });
      },
      //保存付款数据
      saveData(workflowParam) {
        this.workflowParam = workflowParam;
        this.form.adddate = ""; //添加时间由后台绑定
        //出纳办理时，获取付款方式
        var error_msg = "";

        if(this.form.casestatus==6){
          if (this.multipleSelection.length>0) {
            error_msg = "还有没处理完的订单，不允许办结！";
          }
        }else{
          if (this.multipleSelection.length==0) {
            error_msg = "尚未勾选退货单！";
          }
        }

        if (workflowParam.wfhandletype != "draw" &&
          workflowParam.wfhandletype != "back") {
          //退回与撤回不进行验证
          if (error_msg) {
            this.$message({
              message: error_msg,
              type: "error"
            });
            this.showButton();
            return;
          }
        }

        this.$refs.formPayInfo.validate(valid => {
          if (valid) {
            workflowParam.op = this.$refs.wfView.getOption();
            this.form.workflow = JSON.stringify(workflowParam);

            if (this.form.flag) {
              var summary = this.form.uname + "申请退款 " + this.form.hetongname;
              this.form.summary = summary;
            }
            this.saveFuKuanData(workflowParam)
          } else {
            this.showButton();
          }
        });
      },
      saveFuKuanData(workflowParam) {
        this.form.paymoney=this.totalmoney;
        var erpserials=';';
        for(let i in this.multipleSelection) {
          erpserials += this.multipleSelection[i].erpserial + ";";
        }
        this.form.offsetcashjson=erpserials;//存储选择的
        //保存支付数据
        saveOrderBack(this.form, this.form.flag).then(response => {
          if (response.data.code === 0) {
            this.$message({
              message: response.data.msg,
              type: "success"
            });
            if (workflowParam.wfhandletype == "draw") {
              //撤回操作，不关闭页面
              this.editPage(this.form.unitguid);
            } else {
              this.dialogFormVisible = false;
            }
            //刷新列表
            this.$emit("bindGrid");
          } else {
            this.$message({
              message: response.data.msg,
              type: "error"
            });
            this.showButton();
          }
        });
      },
      //删除付款数据
      deleteData() {
        deleteData({
          unitguid: this.form.unitguid
        }).then(response => {
          if (response.data.code === 0) {
            this.$message({
              message: "删除成功！",
              type: "success"
            });
            this.dialogFormVisible = false;
            //刷新列表
            this.$emit("bindGrid");
          } else {
            this.showButton();
            this.$message({
              message: response.data.msg,
              type: "error"
            });
          }
        });
      },
      //初始化页面（新增、修改时都会调用）
      initForm() {
        if (this.$refs.formPayInfo != undefined) {
          this.$refs.formPayInfo.resetFields();
        }
        for (var key in this.form) {
          this.form[key] = "";
        }
        this.orderTable=[];
        this.multipleSelection = [];
        this.totalmoney=0;
        this.clearCustomerName();
        if (this.$refs.AutoCustomer1)
          this.$refs.AutoCustomer1.clearContent();
        this.isShow = false;
        //预先将审批流程 置空
        if (this.$refs.wfView !== undefined) this.$refs.wfView.initData("");
        (this.form.formAllowEdit = true),
        //下面开始给默认字段赋值
        (this.dialogFormVisible = true);
        this.form.flag = true;
        this.isPayStep = false;
      },
      //恢复工作流按钮的 disabled 允许点击，一般在接口报错或者页面校验失败时调用
      showButton() {
        this.$refs.wfHandle.showdisabledButton();
      },
    },

    mounted() {
      this.userModel=JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
      this.isFinancial=this.$checkRight("财务");
    },
    components: {
      CstagreementMachiningEdit,
      CstagreementEdit,
      ConfirmRefundEdit
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/oa/payform/OrderBackEdit.vue